import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from "react-router";
import Page from './components/Page/Page';
import LandingPage from './components/LandingPage/LandingPage';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import 'bootstrap/dist/css/bootstrap.min.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <ScrollToTop />
    <Routes>
      <Route path="/" element={<Page />} />
      <Route path="/estudio" element={<Page />} />
      <Route path="/servicios" element={<Page />} />
      <Route path="/contacto" element={<Page />} />
      <Route path="/proyecto" element={<Page />} />
      <Route path="/landing/:id" element={<LandingPage />} />
      <Route path="/landing" element={<LandingPage />} />
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();